import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { graphql } from 'gatsby';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { media } from '../../theme/media';
import { containerStyles } from '../../styles/layout';
import { headers } from '../../styles/type';

import { ReactComponent as IconCheckMark } from '../../images/icons/check-mark.svg';
import TextRenderer from '../TextRenderer';

const Container = styled.div`
  background-color: ${({ backgroundColor }) => (backgroundColor === 'Blue' ? colors.blue['50'] : colors.white)};
  padding: ${rem(32)} 0;

  ${media('>tiny')} {
    padding: ${rem(56)} 0;
  }
`;

const ContentWrapper = styled.div`
  ${containerStyles.regular}
`;

const Headline = styled.h2`
  ${headers.h3}
  color: ${colors.blue['800']};
  margin-bottom: ${rem(40)};
`;

const ListItems = styled.ul`
  ${media('>small')} {
    column-count: 2;
    column-gap: ${rem(30)};
  }
`;

const ListItem = styled.li`
  color: ${colors.gray['600']};
  display: flex;
  break-inside: avoid;
  margin-bottom: ${rem(24)};
`;

const IconCheckMarkStyled = styled(IconCheckMark)`
  margin-top: ${rem(4)};
  flex-shrink: 0;
  margin-right: ${rem(16)};
`;

const List = ({ headline, list, backgroundColor }) => (
  <Container backgroundColor={backgroundColor}>
    <ContentWrapper>
      <Headline>
        <TextRenderer text={headline} />
      </Headline>
      <ListItems>
        {list?.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <ListItem key={index}>
            <IconCheckMarkStyled aria-hidden="true" role="presentation" />
            <TextRenderer text={item} />
          </ListItem>
        ))}
      </ListItems>
    </ContentWrapper>
  </Container>
);

List.propTypes = {
  headline: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  backgroundColor: PropTypes.oneOf(['Blue', 'White'])
};

export const query = graphql`
  fragment ListFragment on ContentfulList {
    id
    __typename
    headline
    list
    backgroundColor
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

export default List;
